<template>
    <vs-row>
        <vs-button class="ml-auto" type="filled" icon="add_circle" size="small" @click="addingNewItem">
            Add New Banner
        </vs-button>
        <vs-row>
            <vs-col class="d-flex drop-width mb-3" vs-lg="2" vs-xs="12">
                <vs-select :color="colorx" label="Language Filter" v-model="search.language" @change="searchData()">
                    <vs-select-item :key="index" :value="item.culture" :text="item.culture"
                        v-for="(item, index) in languages" />
                </vs-select>
            </vs-col>
            <vs-col class="d-flex drop-width" vs-lg="2" vs-xs="12">
                <vs-select :color="colorx" label="Sorting Type" v-model="search.sort" @change="searchData()">
                    <vs-select-item value text="Select Sorting" disabled />
                    <vs-select-item value="ASC" text="Ascending" />
                    <vs-select-item value="DESC" text="Descending" />
                </vs-select>
            </vs-col>
            <vs-col class="d-flex drop-width" vs-lg="2" vs-xs="12">
                <vs-select :color="colorx" label="Status Filter" v-model="search.status" @change="searchData()">
                    <vs-select-item value text="Select Status" disabled />
                    <vs-select-item value="0" text="All" />
                    <vs-select-item value="1" text="Active" />
                    <vs-select-item value="2" text="Inactive" />
                </vs-select>
            </vs-col>
            <vs-col class="d-flex drop-width" vs-lg="2" vs-xs="12">
                <vs-select :color="colorx" label="Day Filter" v-model="search.isToday" @change="searchData()">
                    <vs-select-item value text="Select Day" disabled />
                    <vs-select-item value="false" text="All" />
                    <vs-select-item value="true" text="Today" />
                </vs-select>
            </vs-col>
            <vs-col vs-lg="4" vs-xs="12">
                <!-- <vs-button color="primary" type="filled" class="searchBtn" @click="searchData()"
                icon="search">Search</vs-button> -->
                <vs-button color="warning" type="filled" class="searchBtn" icon="cached"
                    @click="resetData()">Reset</vs-button>
            </vs-col>
        </vs-row>
        <br />
        <table class="table">
            <tr>
                <th>#</th>
                <td></td>
                <th>Title</th>
                <th>More Details</th>
                <th>Status</th>
                <th>isRepeatable</th>
                <th></th>
            </tr>
            <tr v-for="(item, index) in all" :key="item._id">
                <td class="td">{{ index + 1 }}</td>
                <td>
                    <img v-if="all.length && !item.image" src="../../../../assets/images/No-image.png" height="50px"
                        width="75px" />
                    <img v-if="all.length && item.image" :src="item.image" height="50px" width="75px" />
                </td>
                <td class="td">
                    {{ item.title }}<br />Position - {{ item.position }}<br />Language - {{
                        item.language }}<br />
                    <div class="d-flex" v-if="search.language == 'EN' && item.languageCount">
                        <div class="progress-bar-container mt-3">
                            <div class="progress-bar p-2" :style="{
                                color: item.languageCount - item.missingLanguages.length === item.languageCount ? 'white' : 'black',
                                backgroundColor: item.missingLanguages.length > 0 ? 'red' : item.missingLanguages.length > 1 ? '#06b800' : '',
                                width:
                                    ((item.languageCount - item.missingLanguages.length) / item.languageCount) * 100 + '%'
                            }">
                                <div class="absoluteText">
                                    {{ item.languageCount - item.missingLanguages.length }}/{{ item.languageCount }}
                                </div>
                            </div>
                        </div>
                        <div class="text-center mt-2 d-flex align-items-center" style="font-weight: 800;">
                            <div style="width: 20px; height: 20px; margin-left: 5px"
                                v-popover:tooltip="item.tooltipContent">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
                                    stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round">
                                    <circle cx="12" cy="12" r="10"></circle>
                                    <line x1="12" y1="16" x2="12" y2="12"></line>
                                    <line x1="12" y1="8" x2="12" y2="8"></line>
                                </svg>
                            </div>
                        </div>
                    </div>
                </td>
                <td class="td">
                    <span class="material-icons eye" @click="viewBannerDetails(item)">remove_red_eye</span>
                </td>
                <td class="td">
                    <vs-chip v-if="item.status" color="success">Active</vs-chip>
                    <vs-chip v-else color="danger">Inactive</vs-chip>
                </td>
                <td class="td">
                    <vs-chip v-if="item.isRepeat" color="success">True</vs-chip>
                    <vs-chip v-else color="danger">False</vs-chip>
                </td>
                <td class="td">
                    <vs-button class="mr15 mt-1" icon="create" size="small" color="warning"
                        @click="editingItem(item, 'edit')">Edit</vs-button>
                    <vs-button class="mr15 mt-1" size="small" color="danger" icon="delete_sweep" @click="
                        deleteBannerPopup = true;
                    itemToDelete = item;
                    ">Delete</vs-button>
                    <!-- <vs-button class="mr15 mt-1" size="small" color="primary"
                @click="editingItem(item, 'clone')">Duplicate</vs-button> -->
                </td>
            </tr>
        </table>

        <!-- Code -->
        <vs-popup :title="isNew
            ? 'Add New Banner'
            : clone
                ? 'Duplicate Banner'
                : 'Edit Banner'
            " :active.sync="defaultalert">
            <vs-row>
                <vs-col vs-lg="12" vs-xs="12">
                    <vs-select :color="colorx" label="Language Filter" @change="fileterusingLanguage($event, banner)"
                        v-model="banner.language" icon="arrow_downward" :disabled="isNew">
                        <!-- <vs-select-item value text="All Languages" /> -->
                        <vs-select-item :value="item.culture" :text="item.culture" v-for="(item, index) in languages"
                            :key="index" />
                    </vs-select>
                </vs-col>
                <vs-col vs-lg="12" vs-xs="12">
                    <vs-input label="Banner Title (Keep it Simple and short)" v-model="banner.title" />
                </vs-col>
                <vs-col vs-lg="12" vs-xs="12">
                    <label>Banner Description</label>
                    <vs-textarea width="100%" v-model="banner.description" />
                </vs-col>
                <vs-col vs-lg="12" vs-xs="12">
                    <vs-input type="number" label="Banner Position (Try to assign different position)" :min="1"
                        :max="all.length + 1" v-model="banner.position" />
                </vs-col>
                <vs-col vs-lg="12" vs-xs="12">
                    <vs-input label="Banner LInk" v-model="banner.link" />
                </vs-col>
                <vs-col vs-lg="4" vs-xs="6" class="mt-4">
                    <vs-checkbox v-model="banner.isRepeat">isRepetable (True / False)</vs-checkbox>
                </vs-col>
                <vs-col vs-lg="4" vs-xs="6" class="mt-4">
                    <vs-checkbox v-model="banner.status">Status (Active / Inactive)</vs-checkbox>
                </vs-col>
                <vs-col vs-lg="12" vs-xs="12" class="mb15 mt20">
                    <div>
                        <vs-col vs-lg="12" vs-xs="12" v-if="displayImage == ''">
                            <div class="upload-btn-wrapper vs-input-primary">
                                <label class="vs-input--label">Banner Image (Try to use an image with at least 1000px height (2560x1000 is tested and works))</label>
                                <div class="btn">
                                    <vs-icon icon="cloud_upload" class="icon-medium"></vs-icon>Upload a File
                                </div>
                                <input type="file" ref="fileInput" @change="uploadImage($event, 'image1')" />
                            </div>
                        </vs-col>
                        <vs-col v-if="displayImage">
                            <vs-button color="danger" type="flat" icon="clear" class="closeBtn"
                                @click="deleteImage()"></vs-button>
                            <img :src="displayImage" class="imgUp" height="100px" width="150px" />
                            <b v-if="fileName">File Name : {{ fileName }}</b>
                        </vs-col>
                    </div>
                </vs-col>
                <vs-col vs-lg="4" vs-xs="6">
                    <label>Start Date</label>
                    <br />
                    <datepicker placeholder="Start Date" v-model="banner.startDate" format="yyyy-MM-dd"
                        input-class="form-group">
                    </datepicker>
                </vs-col>
                <vs-col vs-lg="4" vs-xs="6">
                    <label>End Date</label>
                    <br />
                    <datepicker placeholder="End Date" v-model="banner.endDate" format="yyyy-MM-dd"
                        input-class="form-group">
                    </datepicker>
                </vs-col>
                <vs-col vs-lg="9" vs-xs="12" class="mt-2">
                    <vs-button icon="save" style="z-index: 1;" @click="btnAddBanner">{{ isNew ? 'Save English' : 'Update one' }}</vs-button>
                    <vs-button class="ml-3" icon="save" style="z-index: 1;" v-if="isNew" @click="createAndTranslate">Save and
                        Translate</vs-button>
                    <vs-button class="ml-3" icon="save" style="z-index: 1;"
                        v-if="!showLoader && !isNew && !clone && banner.language === 'EN'"
                        @click="updateAndTranslate">Update all</vs-button>
                    <vs-checkbox class="mt-2" style="z-index: 1;" v-model="banner.translate"
                        v-if="!isNew && !clone && banner.language === 'EN'">Update translations</vs-checkbox>
                </vs-col>
            </vs-row>
        </vs-popup>

        <vs-popup class="holamundo" title="Delete Banner" :active.sync="deleteBannerPopup">
            <p>Are you sure you want to delete Banner?</p>
            <div>
                <vs-button icon="delete_forever" class="mr15" @click="deleteBanner">Delete Banner</vs-button>
                <vs-button icon="clear" @click="deleteBannerPopup = false">Cancel</vs-button>
            </div>
        </vs-popup>

        <vs-popup title="View Details" :active.sync="viewDetails">
            <div>
                <h6>Description :</h6>
                <p>{{ detail.description }}</p>
                <h6 v-if="detail.link">Link :</h6>
                <p>{{ detail.link }}</p>
            </div>
        </vs-popup>
        <!-- Code -->

        <div v-if="showLoader" class="loader-container">
            <!-- show text that it is working in background. -->
            <div class="loader"></div>
            <vs-col vs-lg="12" vs-xs="1">
                <p class="loader-text">Translations are in progress.</p>
            </vs-col>
        </div>
        <tooltip :width="300" :pointer="true">
        </tooltip>

    </vs-row>
</template>

<script>
import api from "@/rest.js";
import { API } from "@/common/constants";
// import { generateChart } from 'vue-chartjs';
import Datepicker from "vuejs-datepicker";
import Vue from 'vue'
import VPopover from 'vue-js-popover'

Vue.use(VPopover, { tooltip: true })

export default {
    name: "wBanner",
    components: {
        // uploader,
        Datepicker,
    },
    data: () => ({
        colorx: "primary",
        defaultalert: false,
        viewDetails: false,
        deleteBannerPopup: false,
        isNew: true,
        clone: false,
        search: {
            sort: "ASC",
            language: "EN",
            status: "0",
            isToday: "false",
        },
        displayImage: "",
        fileName: "",
        banner: {
            status: true,
            isRepeat: false,
            language: "EN",
            position: "",
            title: "",
            image: "",
            translate: false,
        },
        itemToDelete: "",
        itemToUpdate: "",
        all: [],
        languages: [],
        detail: {},
        showLoader: false,
    }),
    methods: {
        addingNewItem() {
            this.$data.defaultalert = true;
            this.$data.isNew = true;
            this.$data.clone = false;
            this.$data.banner = {
                status: true,
                isRepeat: false,
                language: "EN",
                position: "",
                title: "",
                image: "",
            };
            this.$data.displayImage = "";
            this.$data.fileName = "";
        },
        editingItem(i, data) {
            this.$data.banner = Object.assign({}, i);
            this.$data.defaultalert = true;
            this.$data.isNew = false;
            this.$data.displayImage = i.image;
            this.$data.clone = data == "clone" ? true : false;
        },
        uploadImage(data, item) {
            if (
                data.target.files[0].type != "image/jpeg" && data.target.files[0].type != "image/jpg" && data.target.files[0].type != "image/webp"
            ) {
                this.$vs.notify({
                    title: "Uploading Error",
                    text: "Only JPEG or JPG Image files formats should be supported",
                    color: "danger",
                    position: "top-right",
                });
                return;
            } else {
                if (data.target.files[0].size > 500000) {
                    this.$vs.notify({
                        title: "Uploading Error",
                        text: "File size should be less than 500kb",
                        color: "danger",
                        position: "top-right",
                    });
                    return;
                }

                let formdata = new FormData();
                this.$data.fileName = data.target.files[0].name;
                formdata.append("file", data.target.files[0]);
                formdata.append("banner", this.$data.banner.title);
                this.$vs.loading();
                api
                    .post(API.UPLOAD_IMAGE, formdata, {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    })
                    .then((response) => {
                        if (response.data.error != null) {
                            this.$vs.loading.close();
                            this.$vs.notify({
                                title: "Uploading Error",
                                text: response.data.error.message,
                                color: "danger",
                                position: "top-right",
                            });
                        } else {
                            const data = response;
                            this.$data.displayImage = response.data.files[0].url;
                            if (response) {
                                this.$vs.notify({
                                    text: "File Uploaded",
                                    color: "success",
                                    position: "top-right",
                                });
                                this.$vs.loading.close();
                            } else {
                                this.$vs.loading.close();
                                this.$vs.notify({
                                    text: "File Uploading Failed",
                                    color: "danger",
                                    position: "top-right",
                                });
                            }
                            this.$refs.fileInput.value = null;
                            this.$emit("input", data);
                        }
                    })
                    .catch(() => { });
                this.$vs.loading.close();
            }
        },
        deleteImage() {
            this.$data.displayImage = "";
        },
        btnAddBanner() {
            this.$vs.loading();
            let apiToCall = API.INSERT_WEB_BANNER;
            let data = this.$data.banner;
            this.$data.banner.image = this.$data.displayImage;

            if (this.$data.clone) {
                apiToCall = API.INSERT_WEB_BANNER;

                data = {
                    description: this.$data.banner.description,
                    endDate: this.$data.banner.endDate,
                    image: this.$data.banner.image,
                    isRepeat: this.$data.banner.isRepeat,
                    language: this.$data.banner.language,
                    link: this.$data.banner.link,
                    position: this.$data.banner.position,
                    startDate: this.$data.banner.startDate,
                    status: this.$data.banner.status,
                    title: this.$data.banner.title,
                };
            }

            let headers = {
                "Content-Type": "application/json;charset=utf-8",
            };

            if (JSON.parse(localStorage.user).token) {
                headers["x-master-token"] = JSON.parse(localStorage.user).token;
            }
            if (this.$data.isNew) {
                api.post(apiToCall, data, { headers })
                    .then((r) => {
                        console.log(r);
                        this.$vs.loading.close();
                        if (r.status) {
                            this.$vs.notify({
                                text: "Saved Successfully",
                                color: "success",
                                position: "top-right",
                            });
                            this.$data.isNew = true;
                            this.$data.itemToUpdate = "";
                            this.$data.defaultalert = false;
                            (this.$data.banner = {
                                status: true,
                                isRepeat: false,
                                language: "",
                                position: "",
                                title: "",
                                image: "",
                            }),
                                this.searchData();
                        } else {
                            this.$vs.notify({
                                title: "Error",
                                text: r.data.error,
                                color: "danger",
                                position: "top-right",
                            });
                        }
                    })
                    .catch(() => {
                        this.$vs.loading.close();
                    });
            }
            if (!this.$data.isNew) {
                apiToCall = API.UPDATE_WEB_BANNER;
                api.put(`${API.UPDATE_WEB_BANNER}/${data._id}`, data, { headers })
                    .then((r) => {
                        this.$vs.loading.close();
                        if (r.status) {
                            this.$vs.notify({
                                text: "Updated Successfully",
                                color: "success",
                                position: "top-right",
                            });
                            this.$data.isNew = true;
                            this.$data.itemToUpdate = "";
                            this.$data.defaultalert = false;
                            (this.$data.banner = {
                                status: true,
                                isRepeat: false,
                                language: "",
                                position: "",
                                title: "",
                                image: "",
                            }),
                                this.searchData();
                        } else {
                            this.$vs.notify({
                                title: "Error",
                                text: r.data.error,
                                color: "danger",
                                position: "top-right",
                            });
                        }
                    });
            }
        },

        async createAndTranslate() {
            let headers = {
                "Content-Type": "application/json;charset=utf-8",
            };

            if (JSON.parse(localStorage.user).token) {
                headers["x-master-token"] = JSON.parse(localStorage.user).token;
            }

            let data = this.$data.banner;
            this.$data.banner.image = this.$data.displayImage;

            this.$data.showLoader = true;
            this.$data.defaultalert = false;

            const res1 = await api.post(API.C_AND_T_WEB_BANNER, data, { headers })
            try {
                this.$vs.loading.close();
                if (res1.status == 200) {
                    this.$vs.notify({
                        text: "Saved Successfully",
                        color: "success",
                        position: "top-right",
                    });
                    this.$data.isNew = true;
                    this.$data.itemToUpdate = "";
                    this.$data.defaultalert = false;
                    (this.$data.banner = {
                        status: true,
                        isRepeat: false,
                        language: "EN",
                        position: "",
                        title: "",
                        image: "",
                    }),
                        await this.searchData();
                    this.$data.showLoader = false;
                }
            } catch (error) {
                this.$data.showLoader = false;
                this.$vs.notify({
                    title: "Error",
                    text: r.data.error,
                    color: "danger",
                    position: "top-right",
                });
                throw error;
            }
        },

        async updateAndTranslate() {
            let headers = {
                "Content-Type": "application/json;charset=utf-8",
            };

            if (JSON.parse(localStorage.user).token) {
                headers["x-master-token"] = JSON.parse(localStorage.user).token;
            }

            let data = this.$data.banner;
            this.$data.banner.image = this.$data.displayImage;
            data.translate = this.$data.banner.translate;

            this.$data.showLoader = true;
            this.$data.defaultalert = false;

            const r = await api.put(`${API.U_AND_T_WEB_BANNER}/${data._id}`, data, { headers })
            try {
                this.$vs.loading.close();
                if (r.status == 200) {
                    this.$vs.notify({
                        text: "Updated Successfully",
                        color: "success",
                        position: "top-right",
                    });
                    this.$data.isNew = true;
                    this.$data.itemToUpdate = "";
                    this.$data.defaultalert = false;
                    this.$data.banner = {
                        status: true,
                        isRepeat: false,
                        language: "",
                        position: "",
                        title: "",
                        image: "",
                    };
                    this.searchData();
                    this.$data.showLoader = false;
                }
            } catch (error) {
                this.$vs.notify({
                    title: "Error",
                    text: error,
                    color: "danger",
                    position: "top-right",
                });
                this.$data.showLoader = false;
                throw error;
            }
        },

        fetchAllBanner() {
            this.$vs.loading();
            api
                .get(API.GET_WEB_BANNER, {})
                .then((r) => {
                    this.$vs.loading.close();
                    this.$data.all = r.data.data
                    console.log(r.data.data)
                    if (!r.status) {
                        this.$vs.notify({
                            title: "Error",
                            text: r.data.error,
                            color: "danger",
                            position: "top-right",
                        });
                    }
                })
                .catch(() => { });
        },
        deleteBanner() {
            let headers = {
                "Content-Type": "application/json;charset=utf-8",
            };

            if (JSON.parse(localStorage.user).token) {
                headers["x-master-token"] = JSON.parse(localStorage.user).token;
            }
            api
                .delete(`${API.DELETE_WEB_BANNER}/${this.$data.itemToDelete._id}`, { headers })
                .then((r) => {
                    if (r.status) {
                        this.$vs.notify({
                            text: "Deleted Successfully",
                            color: "success",
                            position: "top-right",
                        });
                    } else {
                        this.$vs.notify({
                            text: "Already Deleted",
                            color: "danger",
                            position: "top-right",
                        });
                    }
                    this.$data.deleteBannerPopup = false;
                    this.searchData();
                })
                .catch(() => { });
        },
        fileterusingLanguage(event, item) {
            if (event) {
                let headers = {
                    "Content-Type": "application/json;charset=utf-18",
                };
                if (JSON.parse(localStorage.user).token) {
                    headers["token"] = this.$data.token;
                }
                let id = item.ref || item._id;
                this.$vs.loading();
                api.get(`${API.GET_SINGLE_WEB_BANNER}/${id}?language=${event}`, { headers })
                    .then((r) => {
                        this.$data.banner = Object.assign({}, r.data);
                        this.searchData();
                        this.$vs.loading.close();
                    })
                    .catch(() => {
                        this.$vs.loading.close();
                    });
            }
        },
        fetchAllLanguages() {
            this.$vs.loading();
            api
                .get(API.GET_LANG, {})
                .then((r) => {
                    this.$vs.loading.close();
                    this.$data.languages = r.data
                })
                .catch(() => { });
        },
        searchData() {
            this.$vs.loading();
            api
                .get(`${API.GET_WEB_BANNER}?sort=${this.$data.search.sort}&language=${this.$data.search.language}&status=${this.$data.search.status}&isToday=${this.$data.search.isToday}`)
                .then((r) => {
                    this.$vs.loading.close();

                    for (const item of r.data) {
                        item.tooltipContent = item.missingLanguages.length > 0 ? 'Missing Languages: ' + item.missingLanguages.join(', ') : 'All Languages are translated';
                        console.log(item.tooltipContent)
                    }

                    this.$data.all = r.data
                    if (!r.status) {
                        this.$vs.notify({
                            title: "Error",
                            text: r.data.error,
                            color: "danger",
                            position: "top-right",
                        });
                    }
                })
                .catch(() => {
                    this.$vs.loading.close();
                });
        },
        resetData() {
            this.$data.search = {
                sort: "ASC",
                language: "EN",
                status: "1",
                isToday: "false",
            };
            this.searchData();
        },
        viewBannerDetails(i) {
            this.$data.detail.description = i.description;
            this.$data.detail.link = i.link;
            this.$data.viewDetails = true;
        },
    },
    created() {
        this.searchData();
        this.fetchAllLanguages();
    },
};
</script>
<style scoped>
.loader-container {
    background-color: gray;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding-top: 1rem;
    padding-right: 1rem;
    padding-left: 1rem;
    position: fixed;
    bottom: 20px;
    right: 20px;
    z-index: 1000;
}

.loader {
    border: 2px solid white;
    border-top: 2px solid red;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    animation: spin 1s linear infinite;
}

.loader-text {
    color: white;
    text-align: center;
    font-size: 1.2rem;
    margin-top: 10px;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

.mb15 {
    margin-bottom: 15px;
}

.mr15 {
    margin-right: 15px;
}

.td {
    vertical-align: middle;
}

.mt20 {
    margin-top: 20px;
}

.searchBtn {
    margin-top: 25px;
    margin-right: 5px;
    width: 30%;
}

.eye {
    cursor: pointer;
    margin: auto;
}

.upload-btn-wrapper {
    position: relative;
    overflow: hidden;
    display: inline-block;
    width: 100%;
    cursor: pointer !important;
}

.btn {
    border: 1px solid rgba(0, 0, 0, 0.2);
    background-color: white;
    padding: 0.4rem;
    border-radius: 0px;
    font-size: 0.85rem;
    width: 100%;
    cursor: pointer;
}

.upload-btn-wrapper input[type="file"] {
    font-size: 100px;
    position: absolute;
    left: 0;
    top: 0;
    opacity: 0;
}

td {
    padding: 0.5rem;
}

.drop-width {
    width: 150px !important;
}

.progress-bar-container {
    width: 100%;
    background-color: #f3f3f3;
    border: 1px rgba(0, 0, 0, 0.068) solid;
    border-radius: 20px;
    overflow: hidden;
    margin-bottom: 5px;
}

.progress-bar {
    height: 10px;
    transition: width 0.3s ease;
}

.absoluteText {
    text-align: start;
}
</style>
